import api from "./api";

export interface AuditLog {
  id: string;
  action: string;
  entity: string;
  actorRole: string;
  patientName?: string | null;
  createdAt: string;
}

/* ============================
   ADMIN AUDITS (EXISTING)
============================ */

export const getRecentAuditLogs = async () => {
  const res = await api.get("/audit/recent");
  return res.data;
};

export interface AuditFilters {
  search?: string;
  dateFrom?: string;
  dateTo?: string;
  performedBy?: string;
  userRole?: string;
  entityType?: string;
  action?: string;
  fieldName?: string;
}

export const getAllAuditLogs = async (filters: AuditFilters = {}) => {
  const res = await api.get("/audit", { params: filters });
  return res.data;
};

/* ============================
   DOCTOR AUDITS (EXISTING + ADDED)
============================ */

// ✅ Recent (last 5) patient-related audits for doctor
export const getDoctorRecentPatientAuditLogs = async () => {
  const res = await api.get("/audit/doctor/patients/recent");
  return res.data;
};

// ✅ ALL patient-related audits for doctor
export const getDoctorPatientAuditLogs = async (filters: AuditFilters = {}) => {
  const res = await api.get("/audit/doctor/patients", { params: filters });
  return res.data;
};

export const getDoctorAllPatientAuditLogs = async (filters: AuditFilters = {}) => {
  const res = await api.get("/audit/doctor/patients", { params: filters });
  return res.data;
};

/* ============================
   EXPORT (PDF / EXCEL)
============================ */

export const exportAuditLogs = async (
  format: "pdf" | "xlsx",
  filters: AuditFilters = {}
) => {
  const res = await api.get("/audit/export", {
    params: { ...filters, format },
    responseType: "blob",
  });

  const blob = new Blob([res.data]);
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  const d = new Date();
  const pad = (n: number) => String(n).padStart(2, "0");
  const dateStamp = `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
  link.href = url;
  link.setAttribute("download", `audit-logs-${dateStamp}.${format}`);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
  return true;
};

/* ============================
   ✅ NEW ADDITION (ONLY CHANGE)
   DOCTOR → MDT SUBMITTED (DASHBOARD)
============================ */

export const getDoctorSubmittedMdtsForDashboard = async () => {
  const res = await api.get("/audit/doctor/mdt/submitted");
  return res.data;
};

